export default class AdditionalGuestTypeFields {
  public ridingTollTicketType: number;
  public guestTypeRadioOptionValue: string;

  public constructor(
    ridingTollTicketType?: number,
    guestTypeRadioOptionValue?: string
    ){
      this.ridingTollTicketType = ridingTollTicketType || 1;
      this.guestTypeRadioOptionValue = guestTypeRadioOptionValue || ''
    }

  public dehydrate(): string {
    return JSON.stringify(this);
  }

  public static hydrate(jsonObject: any): AdditionalGuestTypeFields | null {
    // console.log("Hydrate AdditionalGuestTypeFields");
    if (!jsonObject) {
      return null;
    }
    return new AdditionalGuestTypeFields(
      jsonObject.ridingTollTicketType,
      jsonObject.guestTypeRadioOptionValue
    );
  }    
};